import React from "react";
import "./OfferServiceItem/OfferServiceItem.css";

const OfferServiceItem = ({ 
  service, 
  onEdit, 
  onDelete,
  isCompact = false // For a more compact display in the offer summary
}) => {
  const { 
    id, 
    title, 
    description, 
    price, 
    discountPercent, 
    category, 
    isRecurring, 
    imageUrl
  } = service;

  // Calculate discounted price
  const discountedPrice = price - (price * (discountPercent / 100));
  
  // Format prices
  const formatPrice = (value) => {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // Total price without discount
  const totalPrice = price;
  
  // Total price with discount
  const finalPrice = totalPrice - (totalPrice * (discountPercent / 100));

  // Compact view for offer summary
  if (isCompact) {
    return (
      <div className="offer-service-item__compact">
        {imageUrl && (
          <div className="offer-service-item__compact-image">
            <img src={imageUrl} alt={title} />
          </div>
        )}
        <div className="offer-service-item__compact-content">
          <h4 className="offer-service-item__compact-title">{title}</h4>
          <div className="offer-service-item__compact-price">
            {discountPercent > 0 ? (
              <>
                <span className="offer-service-item__original-price">{formatPrice(totalPrice)}€</span>
                <span className="offer-service-item__discounted-price">{formatPrice(finalPrice)}€</span>
                <span className="offer-service-item__discount-badge">-{discountPercent}%</span>
              </>
            ) : (
              <span className="offer-service-item__price">{formatPrice(totalPrice)}€</span>
            )}
            {isRecurring && (
              <span className="offer-service-item__recurring-badge">Recurring</span>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Normal view for service list
  return (
    <div className="offer-service-item">
      <div className="offer-service-item__content">
        <div className="offer-service-item__header">
          <h3 className="offer-service-item__title">{title}</h3>
          {category && <span className="offer-service-item__category">{category}</span>}
        </div>
        
        <div 
          className="offer-service-item__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        
        <div className="offer-service-item__details">
          <div className="offer-service-item__price-container">
            {discountPercent > 0 ? (
              <>
                <span className="offer-service-item__original-price">{formatPrice(totalPrice)}€</span>
                <span className="offer-service-item__discounted-price">{formatPrice(finalPrice)}€</span>
                <span className="offer-service-item__discount-badge">-{discountPercent}%</span>
              </>
            ) : (
              <span className="offer-service-item__price">{formatPrice(totalPrice)}€</span>
            )}
          </div>
          
          {isRecurring && (
            <div className="offer-service-item__recurring">
              <span>Recurring</span>
            </div>
          )}
        </div>
      </div>
      
      {imageUrl && (
        <div className="offer-service-item__image">
          <img src={imageUrl} alt={title} />
        </div>
      )}
      
      <div className="offer-service-item__actions">
        <button 
          className="offer-service-item__btn-edit" 
          onClick={() => onEdit(service)}
          title="Edit"
        >
          Edit
        </button>
        <button 
          className="offer-service-item__btn-delete" 
          onClick={() => onDelete(id)}
          title="Delete"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default OfferServiceItem; 